import { RouteProps } from 'routes/AppRouter'
import { ProfesionalTable as ProfesionalTableView } from 'features/profesionals'
import React from 'react'
import { useTitleHeaderContext } from 'common/utils/TitleHeaderContext'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/system'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'

export function ProfesionalTable(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <ProfesionalTableView />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
